import React from 'react';
import { t, props } from 'tcomb-react';

@props({
  children: t.Str
})
export default class HTMLComponent extends React.Component {

  render() {

    return (
      <span dangerouslySetInnerHTML={{__html: this.props.children}}>
      </span>
    );
  }

}




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/HTMLComponent.js
 **/